import { Injectable } from '@angular/core'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { DialogService } from '@tokeet-frontend/tv3-platform'
import {
  LastMinuteAutomationDialogComponent,
  LastMinuteAutomationDialogInput,
} from './last-minute-automation-dialog.component'

@Injectable()
export class LastMinuteAutomationDialogService {
  constructor(private dialog: DialogService) {}

  public open(data?: LastMinuteAutomationDialogInput) {
    const defaultConfig: MatDialogConfig<LastMinuteAutomationDialogInput> = {
      width: '800px',
      height: 'auto',
      data: data || {},
    }

    return this.dialog.openVariableDialog(LastMinuteAutomationDialogComponent, defaultConfig)
  }
}
